import { AccountModel } from "./account";

export interface PaginatedReponse<T> {
	data: T[];
	totalCount: number;
}

export interface SubscriptionApiResponse<T = any> {
	isSuccess: boolean;
	message: string;
	result?: T;
}

export interface Currency {
	code: string;
	name: string;
	symbol: string;
}

export type Invoice = {
	id: string;
	invoiceNumber: string;
	issueDate: string;
	dueDate: string;
	paymentMethod: PaymentMethodEnum;
	currency: Currency;
	total: number;
	status: number;
	statusString: string;
	createdAt: string;
	updatedAt: string;
};

export enum PaymentMethodEnum {
	Visma = "visma",
	Stripe = "stripe",
}

export type InvoiceDownloadResult = {
	id: string;
	url: string;
};

export enum InvoiceStatusEnum {
	UNPAID = 0,
	PAID = 1,
	OVERDUE = 2,
	CANCELLED = 3,
}

export enum SubscriptionStatusEnum {
	INACTIVE = 0,
	ACTIVE = 1,
	EXPIRED = 2,
	CANCELLED = 3,
}

export enum SubscriptionTypeEnum {
	Test = 0,
	Paid = 1,
}

export interface Subscription {
	id: string;
	subscriptionNumber: string;
	accountId: string;
	// account: AccountModel;
	type: SubscriptionTypeEnum;
	typeString: string;
	quantity: number;
	available: number;
	startDate: string;
	planId: string;
	plan: PlanInfoModel;
	planPricingId: string;
	planPricing: PlanPricingInfoModel;
	periodStartDate: string;
	periodEndDate: string;
	status: number;
	statusString: string;
	createdAt?: string;
	renewalStatus?: boolean;
	updatedAt?: string;
	invoices: Invoice[];
	histories: SubscriptionHistoryModel[];
	nodes: SubscriptionNodeModel[];
}

export interface SubscriptionHistoryModel {
	id: string;
	// user: UserModel;
	status: number;
	statusString: string;
	notes: string;
	createdAt: string;
	updatedAt: any;
}
export interface PlanModel {
	id: string;
	code: string;
	name: string;
	features: string[];
	duration: string;
	active: number;
	pricing: PlanPricingModel[];
	createdAt?: string;
	updatedAt?: string;
}

export interface PlanInfoModel {
	id: string;
	code: string;
	name: string;
	features: string[];
	duration: string;
}
export interface PlanPricingInfoModel {
	id: string;
	basePrice: number;
	unitPrice: number;
	currency: Currency;
}

export interface PlanPricingModel {
	id: string;
	basePrice: number;
	unitPrice: number;
	currency: PlanPricingCurrencyModel;
	taxes: PlanPricingTaxModel[];
	meta: PlanPricingMetaModel[];
}

export interface PlanPricingCurrencyModel {
	id: string;
	code: string;
	name: string;
	symbol: string;
}

export enum TaxTypeEnum {
	Inclusive = 0,
	Exclusive = 1,
}

export interface PlanPricingTaxModel {
	tax: PlanTaxModel;
	type: TaxTypeEnum;
	typeString: string;
}
export interface PlanTaxModel {
	id: string;
	name: string;
	code: string;
	type: number;
	typeString: string;
	rate: number;
}

export interface PlanPricingMetaModel {
	key: string;
	value: string;
}

export interface SubscriptionDetailModel {
	id: string;
	subscriptionNumber: string;
	account: AccountModel;
	type: number;
	typeString: string;
	quantity: number;
	startDate: string;
	plan: PlanInfoModel;
	planPricingId: string;
	planPricing: PlanPricingInfoModel;
	periodStartDate: string;
	periodEndDate: string;
	status: number;
	statusString: string;
	createdAt?: string;
	updatedAt?: string;
	invoices: Invoice[];
	histories: SubscriptionHistoryModel[];
	nodes: SubscriptionNodeModel[];
	renewalStatus?: boolean;
	notes?: string;
	paymentMethod: string;
	schedule: SubscriptionScheduleModel[];
}

export interface SubscriptionInfoModel {
	id: string;
	subscriptionNumber: string;
	plan: PlanInfoModel;
	startDate: string;
	periodStartDate: string;
	periodEndDate: string;
	status: number;
	statusString: string;
	renewalStatus: boolean;
	createdAt?: string;
	updatedAt?: string;
}

export enum SubscriptionScheduleStatusEnum {
	Scheduled = 0,
	Completed = 1,
	Cancelled = 2,
}

export enum SubscriptionScheduleTypeEnum {
	Downgrade = 0,
	Upgrade = 1,
}

export interface SubscriptionScheduleModel {
	id: string;
	subscriptionId: string;
	type: SubscriptionScheduleTypeEnum;
	typeString: string;
	quantity: number;
	paymentMethod: string;
	status: SubscriptionScheduleStatusEnum;
	statusString: string;
	createdAt?: string;
	updatedAt?: string;
}
export interface SubscriptionHistoryModel {
	id: string;
	// user: UserModel;
	status: number;
	statusString: string;
	notes: string;
	createdAt: string;
	updatedAt: any;
}
export interface SubscriptionNodeModel {
	node: string;
	createdAt: string;
	updatedAt: any;
}
export interface SubscriptionPaymentUpdateModel {
	url: string;
}
export interface PaymentMethodModel {
	id: string;
	code: string;
	name: string;
	details: string;
	minimumAmount: number;
	maximumAmount: number;
	currency: string[];
	active: number;
	createdAt: string;
	updatedAt?: string;
}

export interface SubscriptionPurchaseModel {
	checkoutUrl: string;
	invoice: Invoice;
}
